const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
  menuType: state => state.global.menuType,
  pageNames: state => state.global.pageNames,
  nowPageValue: state => state.global.nowPageValue,
  closePageNames: state => state.global.closePageNames,
  requestType: state => state.global.requestType,
  menuMapping: state => state.mapping.menuMapping,
  stationMapping: state => state.mapping.stationMapping,
  company: state => state.global.company,
  stationCut: state => state.global.stationCut,
  department: state => state.global.department,
  sysTypeAll: state => state.global.sysTypeAll,
  Menus: state => state.menu.Menus,
  MenusMe: state => state.menu.MenusMe,
  MenuNum: state => state.menu.MenuNum,
  MenuWidth: state => state.global.menuWidth
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js